import * as DocumentTemplateActions from "./templateActions";

export default DocumentTemplateActions;
